import { createSelector } from 'reselect'

export const getGroup = state => state.group

export const getGroupTitle = createSelector(
    getGroup,
    group => group && group.title
)
